import { useIntl } from "react-intl";
import React, { useState, useRef } from "react";
import ReactGA from "react-ga4";
import * as ReactDOM from "react-dom";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useLocation } from "react-router-dom";

import {
  Banner,
  Content,
  Button,
  Icon,
  ReadyToStart,
  Layout,
  ItemList,
  Tips,
  Column,
} from "../../components";
import "../../components/Banner/Banner.scss";
import useAppContext from "../../context/Context";
import "./DirectDebit.scss";
import cl from "../../banks/quickTransfer_CL.json";
import mx from "../../banks/quickTransfer_MX.json";
import Modal from "../../components/Modal/Modal";
import logoDD from "../../assets/icons/SuscriptionPayments_web.svg";
import lady from "../../assets/images/Lady.png";

import phoneMockup1 from "../../assets/images/Phone_mock00.png";
import phoneMockup2 from "../../assets/images/Phone_mock01.png";

import DD_Screen1 from "../../assets/images/DD_Screen1.png";
import DD_Screen2 from "../../assets/images/DD_Screen2.png";
import DD_Screen3 from "../../assets/images/DD_Screen3.png";

import backgroundGrad from "../../assets/images/Grad_DD.jpg";

import category1 from "../../assets/icons/category1.svg";
import category2 from "../../assets/icons/category2.svg";
import category3 from "../../assets/icons/category3.svg";
import category4 from "../../assets/icons/category4.svg";
import category5 from "../../assets/icons/category5.svg";
import category6 from "../../assets/icons/category6.svg";

gsap.registerPlugin(ScrollTrigger);

export const DirectDebit = () => {
  ReactGA.send({ hitType: "pageview", page: "/quick-transfer" });

  const { setStep, getImages, activeCountry } = useAppContext();
  const intl = useIntl();
  const [bankList, setBankList] = React.useState(null);

  const trigger = useRef(null);

  React.useEffect(() => {
    setStep && setStep(1);
  }, []);

  const handleChangeBank = () => {
    activeCountry === "cl" ? setBankList(cl) : setBankList(mx);
  };
  const [progress, setProgress] = useState(0);
  const [dir, setDir] = useState("FORWARD");

  React.useEffect(() => {
    ScrollTrigger.create({
      trigger: trigger.current,
      start: "top top",
      end: "+=300px",
      pinSpacing: true,
      pin: true,
      markers: false,
      onUpdate: (e) => {
        setProgress(e.progress);
        setDir(e.direction === 1 ? "FORWARD" : "REVERSE");
      },
    });
  }, []);

  React.useEffect(handleChangeBank, [activeCountry]);

  const [openModal, setOpenModal] = useState(false);

  const changeModal = () => {
    setOpenModal(!openModal);
  };

  return (
    <Layout className="quick-transfer">
      {openModal === true &&
        ReactDOM.createPortal(
          <Modal
            changeModal={changeModal}
            content={
              <iframe
                title="Formulario de contacto"
                className="iframe"
                src={
                  activeCountry === "mx"
                    ? "https://share.hsforms.com/14Hl-W1oeQx-uUbcs4v0x5A5l986"
                    : "https://share.hsforms.com/1nESwD7ncTxK4ewZnR1u7yQ5l986"
                }
                frameborder="0"
              ></iframe>
            }
          ></Modal>,
          document.getElementById("portal")
        )}

      <Banner
        customClass="direct-debit"
        background={backgroundGrad}
        styles={{ width: "54%", height: "93.5%" }}
      >
        {
          <Content
            content={
              <div className="banner-top-icon">
                <div style={{ padding: 0 }}>
                  <img
                    src={logoDD}
                    alt="Debito directo icon"
                    height={49}
                    width={49}
                  />
                </div>
                <p>{intl.formatMessage({ id: "direct-debit.section1" })}</p>
              </div>
            }
            title={intl.formatMessage({ id: "direct-debit.section1.title" })}
            subtitle={intl.formatMessage({
              id: "direct-debit.section1.subtitle",
            })}
            footer={
              <>
                <a href="https://dashboard.etpay.com/sign-up">
                  <Button
                    bgColor={"#426DD8"}
                    bgHoverColor="#140F33"
                    color="#fff"
                  >
                    <Icon name={"Icon_Pre"} className="fillable" fill="#fff" />
                    <span>
                      {intl.formatMessage({
                        id: "direct-debit.section1.textButton",
                      })}
                    </span>
                  </Button>
                </a>
              </>
            }
            customClass="grid-6"
          />
        }
        <div
          className="image-banner"
          style={{
            gridColumn: "7 / 13",
            marginTop: "4.7rem",
            width: "100%",
            //   backgroundImage: "url(../../public/Grad_DD.jpg)"
          }}
        >
          {<img src={lady} alt="" />}
        </div>
      </Banner>
      <Tips
        tip1={intl.formatMessage({ id: "direct-debit.section1.tip1" })}
        tip2={intl.formatMessage({ id: "direct-debit.section1.tip2" })}
        tip3={intl.formatMessage({ id: "direct-debit.section1.tip3" })}
        customClass="tips-direct-debit"
      ></Tips>
      <div>
        <section className="section-competition">
          <div className="section2-competition-content">
            <span style={{ color: "#426DD8" }}>
              {" "}
              {intl.formatMessage({ id: "direct-debit.section2.title1" })}
            </span>
            <h4 className="section2-title">
              {intl.formatMessage({ id: "direct-debit.section2.title2" })}
            </h4>
            <p className="section2-text">
              {intl.formatMessage({ id: "direct-debit.section2.text" })}
            </p>
            <div className="container-img-list container-img-list-mobile section3-phoneMockup1-mobile">
              <img
                src={phoneMockup1}
                alt=""
                style={{ position: "relative" }}
                className="section3-phoneMockup1-mobile"
              />
            </div>
          </div>
        </section>
        <section>
          <div className="container-list-section">
            <section className="section3" id="section3">
              <div className="section3-content-text">
                <h3 className="section3-title">
                  {intl.formatMessage({ id: "direct-debit.section3.title" })}
                </h3>
                <p className="section3-p">
                  {intl.formatMessage({ id: "direct-debit.section3.text" })}
                </p>

                <div>
                  <h3 className="section3-title section3-title-margin">
                    {intl.formatMessage({
                      id: "direct-debit.section3.bank.title",
                    })}
                  </h3>
                  <p className="section3-p animation2">
                    {intl.formatMessage({
                      id: "direct-debit.section3.bank.text",
                    })}
                  </p>
                  <div className="section3-container-banks">
                    <div>
                      <div className="section3-container-bank">
                        <Icon name={"Secure"}></Icon>
                        <p className="">
                          {intl.formatMessage({
                            id: "direct-debit.section3.bank.bank1",
                          })}
                        </p>
                      </div>
                      <div className="section3-container-bank">
                        <Icon name={"Secure"}></Icon>
                        <p className="">
                          {intl.formatMessage({
                            id: "direct-debit.section3.bank.bank2",
                          })}
                        </p>
                      </div>

                      <div className="section3-container-bank">
                        <Icon name={"Secure"}></Icon>
                        <p className="">
                          {intl.formatMessage({
                            id: "direct-debit.section3.bank.bank3",
                          })}
                        </p>
                      </div>
                      <div className="section3-container-bank">
                        <Icon name={"Secure"}></Icon>
                        <p className="">
                          {intl.formatMessage({
                            id: "direct-debit.section3.bank.bank4",
                          })}
                        </p>
                      </div>
                      <div className="section3-container-bank">
                        <Icon name={"Secure"}></Icon>
                        <p className="">
                          {intl.formatMessage({
                            id: "direct-debit.section3.bank.bank5",
                          })}
                        </p>
                        <div className="section3-soon">
                          {intl.formatMessage({
                            id: "direct-debit.section3.bank.soon",
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="container-img-list section3-phoneMockup1">
                <img
                  src={phoneMockup1}
                  alt=""
                  style={{ position: "relative" }}
                  ref={trigger}
                  className="section3-phoneMockup1"
                />
              </div>
            </section>
            <div className="container-list-atm">
              <div className="container-img-list">
                <img src={phoneMockup2} alt="" />
              </div>
              <div className="container-list">
                <h3>
                  {intl.formatMessage({ id: "direct-debit.section4.title" })}
                </h3>
                <p className="section3-subtitle-list">
                  {intl.formatMessage({ id: "direct-debit.section4.text" })}
                </p>
                <div className="items-list-atm section4-items-list-atm">
                  <div className="container-check">
                    <ItemList>
                      <Icon name={"Check_DD"}></Icon>
                      <p className="section4-text">
                        <span className="bold">
                          {intl.formatMessage({
                            id: "direct-debit.section4.list.title1",
                          })}{" "}
                        </span>
                        {intl.formatMessage({
                          id: "direct-debit.section4.list.text1",
                        })}
                      </p>
                    </ItemList>
                    <ItemList>
                      <Icon name={"Check_DD"}></Icon>
                      <p className="section4-text">
                        <span className="bold">
                          {intl.formatMessage({
                            id: "direct-debit.section4.list.title2",
                          })}{" "}
                        </span>
                        {intl.formatMessage({
                          id: "direct-debit.section4.list.text2",
                        })}
                      </p>
                    </ItemList>
                    <ItemList>
                      <Icon name={"Check_DD"}></Icon>
                      <p className="section4-text">
                        <span className="bold">
                          {intl.formatMessage({
                            id: "direct-debit.section4.list.title3",
                          })}{" "}
                        </span>
                        {intl.formatMessage({
                          id: "direct-debit.section4.list.text3",
                        })}
                      </p>
                    </ItemList>
                    <ItemList>
                      <Icon name={"Check_DD"}></Icon>
                      <p className="section4-text">
                        <span className="bold">
                          {intl.formatMessage({
                            id: "direct-debit.section4.list.title4",
                          })}{" "}
                        </span>
                        {intl.formatMessage({
                          id: "direct-debit.section4.list.text4",
                        })}
                      </p>
                    </ItemList>
                    <ItemList>
                      <Icon name={"Check_DD"}></Icon>
                      <p className="section4-text">
                        <span className="bold">
                          {intl.formatMessage({
                            id: "direct-debit.section4.list.title5",
                          })}{" "}
                        </span>
                        {intl.formatMessage({
                          id: "direct-debit.section4.list.text5",
                        })}
                      </p>
                    </ItemList>
                  </div>

                  <div className="container-check container-check-margin">
                    <ItemList>
                      <Icon name={"Check_DD"}></Icon>
                      <p className="section4-text">
                        <span className="bold">
                          {intl.formatMessage({
                            id: "direct-debit.section4.list.title6",
                          })}{" "}
                        </span>
                        {intl.formatMessage({
                          id: "direct-debit.section4.list.text6",
                        })}
                      </p>
                    </ItemList>
                    <ItemList>
                      <Icon name={"Check_DD"}></Icon>
                      <p className="section4-text">
                        <span className="bold">
                          {intl.formatMessage({
                            id: "direct-debit.section4.list.title7",
                          })}{" "}
                        </span>
                        {intl.formatMessage({
                          id: "direct-debit.section4.list.text7",
                        })}
                      </p>
                    </ItemList>
                    <ItemList>
                      <Icon name={"Check_DD"}></Icon>
                      <p className="section4-text">
                        <span className="bold">
                          {intl.formatMessage({
                            id: "direct-debit.section4.list.title8",
                          })}{" "}
                        </span>
                        {intl.formatMessage({
                          id: "direct-debit.section4.list.text8",
                        })}
                      </p>
                    </ItemList>
                    <ItemList>
                      <Icon name={"Check_DD"}></Icon>
                      <p className="section4-text">
                        {intl.formatMessage({
                          id: "direct-debit.section4.list.title9",
                        })}{" "}
                      </p>
                    </ItemList>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="container-compatarive section5-padding-bottom">
            <h1 className="title-comparative-section">
              {intl.formatMessage({ id: "direct-debit.section5.title" })}
            </h1>
            <p className="subtitle-comparative-section">
              {intl.formatMessage({ id: "direct-debit.section5.subtitle" })}
            </p>
            <div className="tab-atm">
              <div className="section5-item-tab">
                <div className="content-item">
                  <span>
                    {intl.formatMessage({
                      id: "direct-debit.section5.step1.title",
                    })}
                  </span>
                  <p>
                    {intl.formatMessage({
                      id: "direct-debit.section5.step1.text",
                    })}
                  </p>
                </div>
                <div className="content-item-img">
                  <img src={DD_Screen1} alt="" />
                </div>
              </div>
              <div className="section5-item-tab">
                <div className="content-item">
                  <span>
                    {intl.formatMessage({
                      id: "direct-debit.section5.step2.title",
                    })}
                  </span>
                  <p>
                    {intl.formatMessage({
                      id: "direct-debit.section5.step2.text",
                    })}
                  </p>
                </div>
                <div className="content-item-img">
                  <img src={DD_Screen2} alt="" />
                </div>
              </div>
              <div className="section5-item-tab">
                <div className="content-item">
                  <span>
                    {intl.formatMessage({
                      id: "direct-debit.section5.step3.title",
                    })}
                  </span>
                  <p>
                    {intl.formatMessage({
                      id: "direct-debit.section5.step3.text",
                    })}
                  </p>
                </div>
                <div className="content-item-img">
                  <img src={DD_Screen3} alt="" />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="casos-usos">
            <Column>
              <h4 className="top-title" style={{ color: "#426DD8" }}>
                {intl.formatMessage({ id: "direct-debit.section6.title" })}
              </h4>
              <h2 className="title">
                {intl.formatMessage({ id: "direct-debit.section6.title2" })}
              </h2>
              <h3 className="sub-title">
                {intl.formatMessage({ id: "direct-debit.section6.text" })}
              </h3>
            </Column>
            <div className="container-section6">
              <Column className="section6">
                <div className="section6-container">
                  <div>
                    <img src={category1} alt="" />
                  </div>
                  <div className="section6-category-title">
                    {intl.formatMessage({
                      id: "direct-debit.section6.category1.title",
                    })}
                  </div>
                  <div className="section6-category-text">
                    {intl.formatMessage({
                      id: "direct-debit.section6.category1.text",
                    })}
                  </div>
                </div>
                <div className="section6-container">
                  <div>
                    <img src={category2} alt="" />
                  </div>
                  <div className="section6-category-title">
                    {intl.formatMessage({
                      id: "direct-debit.section6.category2.title",
                    })}
                  </div>
                  <div className="section6-category-text">
                    {intl.formatMessage({
                      id: "direct-debit.section6.category2.text",
                    })}
                  </div>
                </div>
                <div className="section6-container">
                  <div>
                    <img src={category3} alt="" />
                  </div>
                  <div className="section6-category-title">
                    {intl.formatMessage({
                      id: "direct-debit.section6.category3.title",
                    })}
                  </div>
                  <div className="section6-category-text">
                    {intl.formatMessage({
                      id: "direct-debit.section6.category3.text",
                    })}
                  </div>
                </div>
                <div className="section6-container">
                  <div>
                    <img src={category4} alt="" />
                  </div>
                  <div className="section6-category-title">
                    {intl.formatMessage({
                      id: "direct-debit.section6.category4.title",
                    })}
                  </div>
                  <div className="section6-category-text">
                    {intl.formatMessage({
                      id: "direct-debit.section6.category4.text",
                    })}
                  </div>
                </div>
                <div className="section6-container">
                  <div>
                    <img src={category5} alt="" />
                  </div>
                  <div className="section6-category-title">
                    {intl.formatMessage({
                      id: "direct-debit.section6.category5.title",
                    })}
                  </div>
                  <div className="section6-category-text">
                    {intl.formatMessage({
                      id: "direct-debit.section6.category5.text",
                    })}
                  </div>
                </div>
                <div className="section6-container">
                  <div>
                    <img src={category6} alt="" />
                  </div>
                  <div className="section6-category-title">
                    {intl.formatMessage({
                      id: "direct-debit.section6.category6.title",
                    })}
                  </div>
                  <div className="section6-category-text">
                    {intl.formatMessage({
                      id: "direct-debit.section6.category6.text",
                    })}
                  </div>
                </div>
              </Column>
            </div>
          </div>
        </section>

        <section>
          <div className="tarifas section7">
            <Column>
              <h4 className="top-title" style={{ color: "#426DD8" }}>
                {intl.formatMessage({ id: "direct-debit.section7.title1" })}
              </h4>
              <h2 className="title">
                {intl.formatMessage({ id: "direct-debit.section7.title2" })}
              </h2>
              <h3 className="sub-title">
                {intl.formatMessage({ id: "direct-debit.section7.text1" })}
              </h3>
            </Column>
            <Column customClass="content">
              {/* 1 */}
              <div className="title hide-xs">
                {intl.formatMessage({ id: "direct-debit.section7.text2" })}
              </div>
              <div className="text">
                <div className="title show-xs"></div>
                <div className="description">
                  {intl.formatMessage({ id: "direct-debit.section7.text3" })}
                </div>
              </div>
              <div className="value valueContainer">
                <div className="bottom">
                  <a
                    className="section7-button"
                    href="https://dashboard.etpay.com/sign-up"
                  >
                    {intl.formatMessage({ id: "direct-debit.section7.button" })}{" "}
                    <Icon name={"Icon_After"} color="#FCFCFC" />
                  </a>
                </div>
              </div>
            </Column>
          </div>
        </section>

        <ReadyToStart></ReadyToStart>
      </div>
    </Layout>
  );
};
